import {createContext, Dispatch, SetStateAction} from 'react';

interface SelectedPatientContextType {
    selectedPatientId: number;
    setSelectedPatientId: Dispatch<SetStateAction<number>>;
}

export const SelectedPatientContext = createContext<SelectedPatientContextType|0>(0);